<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dp9Eg0/tc-custom/9781504076401.jpg?1723836047849" alt="This image is the cover for the book Senseless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Senseless
      </h1>
      <p class="bookDescription body article font2">
        <b>The damage inflicted on a killer has led him into darkness—and a London detective now faces the most puzzling case of his career, in this taut crime thriller.</b><br/><br/> From the moment he entered the world, Martin was cursed—suffering from withdrawal symptoms because of his mother’s drug abuse, taken home to a world of hunger, pain, and neglect. Eventually landing in care, his sensory abilities are nearly destroyed after years of violence inflicted on him by his mother’s boyfriends.<br/><br/> Tormented by his life as an outcast, Martin dreams of being able to hear and smell and taste like ordinary people—and in a desperate bid to feel alive, he turns to murder . . .<br/><br/> DI Ruben Jameson suddenly finds himself tracking a serial killer. But as he braces himself for the usual escalation and provocation, events take a strange turn—and for the first time, he wonders if he may be dealing with a predator who is trying to stop himself. Now Jameson must find the perpetrator before he slips quietly back into anonymity, never to face justice . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luke Delaney
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6093c0b6